import useScreenSize from './useScreenSize';

interface ChipStyle {
  gap: number;
  height: number;
}

interface UseFilterChipMaxHeightProps {
  chipStyle: ChipStyle;
}

const useFilterChipMaxHeight = ({
  chipStyle,
}: UseFilterChipMaxHeightProps) => {
  const { isXsScreen, isSmScreen } = useScreenSize();
  const isMobileScreen = isXsScreen;
  const isTabletScreen = isSmScreen;
  
  const getTruncationLines = () => {
    if (isMobileScreen) return 5;
    if (isTabletScreen) return 3;
    return 2;
  };

  const maxHeight = `${(chipStyle.height * getTruncationLines()) + (chipStyle.gap * (getTruncationLines() - 1))}px`;

  return maxHeight;
};

export default useFilterChipMaxHeight;
